import { cn } from '@/lib/utils';

const typeConfig: Record<string, { text: string; bg: string; icon: string }> = {
  sprint:  { text: '#7C3AED', bg: '#EDE9FE', icon: '\u26A1' },
  goal:    { text: '#059669', bg: '#D1FAE5', icon: '\u25CE' },
  general: { text: '#2563EB', bg: '#DBEAFE', icon: '\u2630' },
};

interface TypeBadgeProps {
  type: string;
  className?: string;
}

export function TypeBadge({ type, className }: TypeBadgeProps) {
  const config = typeConfig[type] ?? typeConfig.general!;
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium', className)}
      style={{ color: config.text, backgroundColor: config.bg }}
    >
      <span>{config.icon}</span>
      {type.charAt(0).toUpperCase() + type.slice(1)}
    </span>
  );
}
